import styled from 'styled-components';
import { Pressable } from '@cbhq/cds-web/system/Pressable';
import { useAnalyticsContext } from '../../providers/AnalyticsProvider.js';
import { useLinkComponent } from '../../providers/LinkComponentProvider.js';
import { useLocaleContext } from '../../providers/LocaleProvider.js';
import { cleanUrlDuplicateSlashes } from '../../utils/cleanUrlDuplicateSlashes.js';
import { getIsAnchorLink } from '../../utils/getIsAnchorLink.js';
import { getIsRelativeUrl } from '../../utils/getIsRelativeUrl.js';
import { getLocalizedUrl } from '../../utils/getLocalizedUrl.js';
import { scrollToAnchor } from '../../utils/scrollToAnchor.js';
import { useIsExternalUrl } from './useIsExternalUrl.js';
import { jsx } from 'react/jsx-runtime';
const WrappedPressable = styled(Pressable)`
  margin: 0;
  padding: 0;
  border: 0;
  display: contents;
`;
function LinkPressable({
  children,
  rel,
  target,
  href = '',
  width,
  'data-qa': dataQa = ''
}) {
  const cleanHref = cleanUrlDuplicateSlashes(href);
  const isRelativeUrl = getIsRelativeUrl(cleanHref);
  const isAnchorLink = getIsAnchorLink(cleanHref);
  const isExternalUrl = useIsExternalUrl(cleanHref);
  const LinkComponent = useLinkComponent();
  const _useAnalyticsContext = useAnalyticsContext(),
    analyticsPrefix = _useAnalyticsContext.analyticsPrefix;
  const _useLocaleContext = useLocaleContext(),
    locale = _useLocaleContext.locale;
  const localizedUrl = isRelativeUrl ? cleanHref : getLocalizedUrl(cleanHref, locale);
  const finalDataQa = `${analyticsPrefix}${dataQa && analyticsPrefix ? '-' : ''}${dataQa}`;

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
  const onAnchorLinkPress = event => {
    event.preventDefault();
    scrollToAnchor(cleanHref.replace('#', ''));
  };
  if (!!LinkComponent && isRelativeUrl) {
    return (/*#__PURE__*/
      // eslint-disable-next-line @cbhq/react-no-nested-component -- TODO Fix this
      jsx(LinkComponent, {
        href: cleanHref,
        "data-qa": finalDataQa,
        children: /*#__PURE__*/jsx(WrappedPressable, {
          "data-qa": finalDataQa,
          background: "transparent",
          noScaleOnPress: true,
          as: "a",
          color: "foregroundMuted",
          rel: rel,
          target: target,
          href: cleanHref,
          width: width,
          children: children
        })
      })
    );
  }
  return /*#__PURE__*/jsx(Pressable, {
    "data-qa": finalDataQa,
    background: "transparent",
    noScaleOnPress: true,
    as: "a",
    color: "foregroundMuted",
    rel: rel,
    href: localizedUrl,
    width: width,
    target: isExternalUrl ? '_blank' : target,
    onPress: isAnchorLink ? onAnchorLinkPress : undefined,
    children: children
  });
}
export { LinkPressable };
//# sourceMappingURL=LinkPressable.js.map
